import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiservicepune() {



  const cardData = {
"keyword": "Outstation Taxi Service Pune",

"headingDescription":
  "Shivai Travels offers reliable and affordable Outstation Taxi Service Pune for comfortable travel to nearby cities, tourist destinations, business meetings, family trips, airport transfers, and weekend getaways. With experienced drivers, clean and well-maintained vehicles, transparent pricing, and timely pickups, we ensure a safe and stress-free journey for every traveler. Our fleet includes air-conditioned sedans, spacious SUVs, and premium cars suitable for solo travelers, families, and corporate clients. Whether you need one-way travel, round-trip taxi service, or customized outstation packages, Shivai Travels provides flexible booking options with 24/7 customer support and dependable service quality.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a scenic hill station near Pune famous for waterfalls, green valleys, and pleasant weather. Travelers using Outstation Taxi Service Pune can comfortably enjoy a refreshing getaway surrounded by natural beauty."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a popular hill destination known for strawberry farms, cool climate, and panoramic viewpoints. Booking an outstation taxi from Pune makes it convenient to explore this peaceful tourist destination."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a vibrant metropolitan city known for iconic attractions, beaches, shopping streets, and business centers. Travelers using outstation taxi services from Pune can enjoy a smooth and comfortable journey to the city."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba and attracts devotees from across the country. Outstation Taxi Service Pune offers a comfortable and convenient travel option for spiritual visits to Shirdi."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for temples, vineyards, and religious tourism. Travelers from Pune can easily book an outstation taxi to enjoy sightseeing, spiritual visits, and wine tourism experiences."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is known for Mahalaxmi Temple, historical attractions, and traditional cuisine. A taxi from Pune provides a relaxing and convenient travel experience to explore this culturally rich city."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of India’s most popular beach destinations famous for nightlife, beaches, water sports, and seafood. Travelers booking outstation taxis from Pune can enjoy a comfortable and enjoyable road trip to Goa."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is known for historical monuments including Ajanta and Ellora Caves along with rich Mughal heritage. An outstation taxi from Pune offers a convenient travel option for exploring these famous heritage sites."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a peaceful coastal town known for beaches, forts, and relaxing weekend trips. Travelers using Pune outstation taxi services can enjoy a smooth and scenic road journey to this beach destination."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for scenic landscapes, waterfalls, and historic forts surrounded by the Sahyadri hills. Outstation Taxi Service Pune makes it easy for travelers to enjoy a refreshing and comfortable trip to this beautiful destination."
  }
],



services: [
  {
    name: "Outstation Taxi Service Pune",
    description: "Outstation taxi service Pune provides reliable transportation for passengers traveling from Pune to nearby cities, tourist destinations, and business hubs. Comfortable vehicles with experienced drivers ensure safe and smooth highway journeys for families, tourists, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel needs. Flexible booking options allow convenient one-way and round-trip travel reservations."
  },
  {
    name: "Pune Outstation Taxi",
    description: "Pune outstation taxi service offers dependable cab transportation for long-distance journeys from Pune to various destinations. Vehicles provide spacious seating and smooth highway travel experience suitable for business trips, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including residential areas, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy outstation taxi reservations."
  },
  {
    name: "Long Distance Taxi Pune",
    description: "Long distance taxi Pune service provides comfortable transportation for passengers planning intercity and highway travel from Pune. Vehicles are maintained for smooth long-route journeys with spacious seating and luggage capacity suitable for extended travel. Professional drivers ensure safe driving and timely pickup services for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient long-distance taxi reservations."
  },
  {
    name: "Intercity Taxi Pune",
    description: "Intercity taxi Pune service offers reliable transportation between Pune and nearby cities with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway and highway travel ensuring smooth and safe journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, and family visits. Flexible booking options allow convenient intercity taxi reservations."
  },
  {
    name: "One Way Taxi Pune Outstation",
    description: "One way taxi Pune outstation service provides economical transportation for passengers traveling from Pune to other cities without return travel requirements. Comfortable vehicles ensure smooth highway journeys with professional drivers offering punctual pickup services. Ideal for airport transfers, corporate travel, family visits, and tourism trips. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient one-way taxi reservations."
  },
  {
    name: "Round Trip Taxi Pune",
    description: "Round trip taxi Pune service offers convenient return transportation for passengers planning outstation journeys from Pune. Comfortable vehicles provide smooth city and highway travel with experienced drivers ensuring safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, family trips, tourism, and pilgrimage tours. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Outstation Taxi Booking Pune",
    description: "Outstation taxi booking Pune service allows passengers to reserve comfortable taxis for long-distance journeys from Pune. Vehicles include sedans, SUVs, luxury cars, and premium taxis suitable for different travel requirements. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow instant and advance taxi reservations."
  },
  {
    name: "Pune to Outstation Taxi",
    description: "Pune to outstation taxi service provides reliable transportation from Pune to tourist destinations, pilgrimage locations, business cities, and nearby towns. Vehicles offer comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe journeys for passengers. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient one-way and round-trip taxi reservations."
  },
  {
    name: "Best Outstation Taxi Pune",
    description: "Best outstation taxi Pune service offers premium travel experience with comfortable vehicles and professional chauffeurs for long-distance journeys. Vehicles provide spacious seating, luggage capacity, and smooth ride quality suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Cheap Outstation Taxi Pune",
    description: "Cheap outstation taxi Pune service provides affordable transportation for passengers looking for economical intercity travel from Pune. Comfortable vehicles ensure reliable highway travel while maintaining budget-friendly pricing for travelers. Professional drivers ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and cost-effective outstation taxi reservations."
  },
  {
    name: "SUV Outstation Taxi Pune",
    description: "SUV outstation taxi Pune service provides spacious and comfortable transportation for families and groups traveling from Pune to outstation destinations. SUV vehicles offer excellent highway performance, luggage space, and comfortable seating suitable for long-distance journeys. Professional drivers ensure safe driving and smooth travel experience for passengers. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Sedan Outstation Taxi Pune",
    description: "Sedan outstation taxi Pune service offers economical and comfortable transportation for intercity travel from Pune. Sedan vehicles provide smooth highway travel and comfortable seating suitable for solo travelers, couples, and small families. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Pune Outstation Taxi Fare",
    description: "Pune outstation taxi fare service provides transparent pricing information for passengers planning long-distance travel from Pune. Travelers can estimate transportation costs based on destination, vehicle type, and travel requirements. Comfortable vehicles ensure smooth highway journeys with professional drivers providing reliable travel services. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient fare planning and taxi reservations."
  },
  {
    name: "Luxury Outstation Taxi Pune",
    description: "Luxury outstation taxi Pune service provides premium transportation with high-end vehicles and professional chauffeurs for comfortable long-distance travel. Luxury vehicles offer spacious interiors, smooth ride quality, and advanced travel comfort suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury taxi reservations."
  },
  {
    name: "Corporate Outstation Taxi Pune",
    description: "Corporate outstation taxi Pune service provides professional transportation solutions for business travelers and corporate employees traveling from Pune to other cities. Comfortable vehicles ensure smooth highway travel with experienced chauffeurs maintaining punctuality and professionalism. Pickup services are available from offices, hotels, homes, railway stations, and airport terminals. Ideal for business meetings, corporate events, and official travel requirements. Flexible booking options allow convenient corporate taxi reservations."
  },
  {
    name: "24x7 Outstation Cab Service Pune",
    description: "24x7 outstation cab service Pune provides round-the-clock transportation for passengers traveling from Pune to outstation destinations at any time. Comfortable vehicles and professional drivers ensure safe and reliable highway journeys for airport transfers, business trips, tourism, and emergency travel needs. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation cab reservations anytime."
  }
],

tableData: [
  ["Outstation Taxi Service Pune", "Pune Outstation Taxi"],
  ["Long Distance Taxi Pune", "Intercity Taxi Pune"],
  ["One Way Taxi Pune Outstation", "Round Trip Taxi Pune"],
  ["Outstation Taxi Booking Pune", "Pune to Outstation Taxi"],
  ["Best Outstation Taxi Pune", "Cheap Outstation Taxi Pune"],
  ["SUV Outstation Taxi Pune", "Sedan Outstation Taxi Pune"],
  ["Pune Outstation Taxi Fare", "Luxury Outstation Taxi Pune"],
  ["Corporate Outstation Taxi Pune", "24x7 Outstation Cab Service Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Experienced Outstation Taxi Drivers",
        WhyChoosedescription: "Shivai Travels provides experienced drivers for outstation taxi service in Pune who are familiar with major highways, hill stations, pilgrimage routes, and intercity travel destinations for safe and smooth journeys."
      },
      {
        WhyChooseheading: "Affordable Outstation Taxi Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable and transparent outstation taxi service Pune pricing with no hidden charges. Customers receive complete fare details including tolls and driver allowances before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Outstation Taxi Availability",
        WhyChoosedescription: "Our outstation taxi service in Pune operates 24 hours a day for family trips, business travel, airport transfers, weekend tours, and emergency travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, regularly cleaned, and well maintained to ensure comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "Flexible One Way & Round Trip Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way outstation taxis, round-trip bookings, multi-day travel plans, and customized tour packages from Pune."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Reliable Pune Outstation Taxi Service",
        WhyChoosedescription: "Shivai Travels is trusted for reliable outstation taxi service in Pune with punctual pickups, professional drivers, comfortable vehicles, and smooth intercity transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is outstation taxi service Pune?", answer: "Outstation taxi service Pune provides transportation from Pune to nearby cities, tourist destinations, pilgrimage places, and long-distance travel locations." },
    { question: "Is outstation taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 outstation taxi service from Pune." },
    { question: "Which vehicles are available for outstation travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers for outstation journeys." },
    { question: "Can I book a one-way outstation taxi from Pune?", answer: "Yes, customers can book both one-way and round-trip outstation taxi services from Pune." },
    { question: "Do you provide Pune Airport pickup service?", answer: "Yes, Shivai Travels provides airport pickup and drop services along with doorstep pickup across Pune." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book outstation taxis online?", answer: "Yes, customers can easily book outstation taxi service Pune online or through phone booking." },
    { question: "Do you provide taxis for family trips?", answer: "Yes, Shivai Travels provides comfortable taxis for family vacations, group tours, and weekend getaways." },
    { question: "Are outstation taxi fares transparent?", answer: "Yes, Shivai Travels provides transparent and affordable pricing without hidden charges." },
    { question: "Is advance booking available for outstation taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akash Jagtap",
      feedback:
        "Excellent outstation taxi service from Pune by Shivai Travels. The cab was clean and the driver was very professional.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Swati Desai",
      feedback:
        "Booked an outstation trip with Shivai Travels. Affordable pricing, comfortable vehicle, and smooth travel experience.",
      rating: 5
    }
  ];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service Pune",
  "image": "https://shivaitravels.com/assets/images/outstation-taxi-pune.jpg",
  "description": "Book outstation taxi service in Pune for one-way and round-trip travel. Shivai Travels offers affordable sedan, SUV, Innova, and luxury taxis for Pune to Mumbai, Shirdi, Goa, and other long-distance destinations with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/outstation-taxi-service-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Outstation Taxi Service Pune | Affordable One Way & Round Trip Cabs | +91 9689815477</title>

  <meta
    name="description"
    content="Book outstation taxi service in Pune for Pune to Mumbai, Goa, Shirdi and more. Affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Outstation taxi service pune, pune outstation taxi, long distance taxi pune, intercity taxi pune, one way taxi pune outstation, round trip taxi pune, outstation taxi booking pune, pune to outstation taxi, best outstation taxi pune, cheap outstation taxi pune, suv outstation taxi pune, sedan outstation taxi pune, pune outstation taxi fare, luxury outstation taxi pune, corporate outstation taxi pune, outstation taxi service in pune, Outstation taxi in pune, Outstation cabs pune to mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationtaxiservicepune;